import {
  CreateShippingRateTableInputSchema,
  type ICreateShippingRateTableInput,
} from "@redotech/redo-model/integration/redo-in-shipping/shipping-rate-table";
import * as zExt from "@redotech/rpc/ext";
import * as z from "zod/v4";
import { validationResponseSchema } from "./validation-schemas";

export const updateShippingMethod = {
  name: "updateShippingMethod" as const,
  input: z.object({
    checkoutExperienceId: zExt.objectId(),
    shippingMethodId: zExt.objectId(),
    shippingRateTable:
      CreateShippingRateTableInputSchema as ICreateShippingRateTableInput,
    skipValidation: z.boolean().optional(),
  }),
  output: validationResponseSchema,
};
export type UpdateShippingMethodInput = z.infer<
  typeof updateShippingMethod.input
>;
